export const getCdnAssetUrl = (path: string | undefined) => {
  if (!path) return ""
  return `${path}?v=${import.meta.env.VITE_APP_VERSION}`
}
